const recommeneded_section = document.querySelector('.product-recommendations');

const options = {
  rootMargin: '400px'
}

const observer = new IntersectionObserver(entry => {

  if (entry[0].isIntersecting == true) {

    observer.unobserve(recommeneded_section);

    const productRecommendationsSection = document.querySelector('.product-recommendations');
    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then(response => {
        if (!response.ok) {
          console.error("response was not ok");
          return null;
        }
        return response.text();
      })
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');
        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;

          const newQuickButtons = productRecommendationsSection.querySelectorAll('[open-quick-view]');
          newQuickButtons.forEach(btn => {
            btn.addEventListener(
              'click',
              window.globalListeners.openQuickView.bind(window.globalListeners)
            );
          });

          const newQuickCloses = productRecommendationsSection.querySelectorAll('.quick-view-container .close');
          newQuickCloses.forEach(closeBtn => {
            closeBtn.addEventListener(
              'click',
              window.globalListeners.closeQuickView.bind(window.globalListeners)
            );
          });

          const swiper_recommended = new window.swiper('.recommendations-slider', {
            slidesPerView: 1.5,
            spaceBetween: 20,
            resizeObserver: true,
            navigation: {
              nextEl: ".swiper-button-next.cart-rec",
              prevEl: ".swiper-button-prev.cart-rec",
            },
            lazy: {
              enabled: true,
              checkInView: false,
              loadOnTransitionStart: true,
              loadPrevNext: true,
              loadPrevNextAmount: 1
            },
            breakpoints: {
              768: {
                slidesPerView: 2,
              },
              1025: {
                slidesPerView: 3,
                spaceBetween: 30,
              },
              1200: {
                slidesPerView: 4,
              },
            },
          });
        }
      })
      .catch(error => {
        console.error(error);
      });
  }

}, options);

observer.observe(recommeneded_section);
